import React, { VFC } from 'react';
import styled from 'styled-components';
import { Image } from '~/models/Instagram/InstagramModel';
import { X_SMALL_IMAGE_SIZE, LARGE_IMAGE_SIZE } from '../constants';
import ImageLink from './ImageLink';

const ImagesWrapper = styled.div`
  display: flex;
`;
const RestImageWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

interface Props {
  images: Image[];
}
const PcImagesComponent: VFC<Props> = ({ images }: Props) => {
  const firstImage = images[0];
  const restImages = images.slice(1, 9);

  return (
    <ImagesWrapper>
      <ImageLink size={LARGE_IMAGE_SIZE} image={firstImage} />
      <RestImageWrapper>
        {restImages.map((image) => (
          <ImageLink size={X_SMALL_IMAGE_SIZE} image={image} />
        ))}
      </RestImageWrapper>
    </ImagesWrapper>
  );
};

export default PcImagesComponent;
